import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { DecisionGridEvictionService } from 'src/app/decision-grid/Services/decision-grid-eviction.service';
import { ScreeningAdditionalData } from 'src/app/models/screeningInvite';
import { EvictionSettingModel } from 'src/app/decision-grid/Models/criminal-model';

@Component({
  selector: 'app-decision-grid-eviction-settings-read',
  templateUrl: './decision-grid-eviction-settings-read.component.html',
  styleUrls: ['./decision-grid-eviction-settings-read.component.less']
})
export class DecisionGridEvictionSettingsReadComponent {
  @Input() pkg : ScreeningAdditionalData;
  @Input() locationId : number;
  evictSub$: Subscription;

  
  public get settings() : EvictionSettingModel[] {
    let fltrd = this.evict.evictionSettings.filter(st=>{ return st.clientLocationId == this.locationId});
    if(fltrd.length > 0) return fltrd;
    else return this.evict.evictionSettings.filter(st=>{ return st.clientLocationId == 0});
  }
  

  public constructor(public evict : DecisionGridEvictionService){}
  ngOnDestroy(): void {
    if(this.evictSub$) this.evictSub$.unsubscribe();

  }
  ngOnInit(): void {
    console.log('data: ',this.locationId);
    this.evictSub$ = this.evict.getEvictionSettings(this.pkg.clientId).subscribe();
  }
}
